import {
	FETCH_SUPPORT_SUBJECTS,
	HIDE_USA_BUDGET_MODAL_CONFIRMACION,
	SEND_REQUEST_BUDGET_USA,
	FETCH_BUSINESS_ACTIVITIES_TYPE
} from '@/redux/actions/support.actions'

const initalState = {
	loading: false,
	error: false,
	subjects: [],
	budgetRequestCompleted: false,
	bussinesActivitiesById: {}
}

const loading = (state = initalState.loading, action) => {
	switch (action.type) {
		case FETCH_SUPPORT_SUBJECTS.REQUEST:
			return true
		case FETCH_SUPPORT_SUBJECTS.SUCCESS:
		case FETCH_SUPPORT_SUBJECTS.FAILURE:
			return false
		default:
			return state
	}
}

const error = (state = initalState.error, action) => {
	switch (action.type) {
		case FETCH_SUPPORT_SUBJECTS.FAILURE:
			return true
		case FETCH_SUPPORT_SUBJECTS.REQUEST:
		case FETCH_SUPPORT_SUBJECTS.SUCCESS:
			return false
		default:
			return state
	}
}

const subjects = (state = initalState.subjects, action) => {
	switch (action.type) {
		case FETCH_SUPPORT_SUBJECTS.REQUEST:
			return []
		case FETCH_SUPPORT_SUBJECTS.SUCCESS:
			return action.payload
		case FETCH_SUPPORT_SUBJECTS.FAILURE:
			return []
		default:
			return state
	}
}

const budgetRequestCompleted = (state = initalState.budgetRequestCompleted, action) => {
	switch (action.type) {
		case SEND_REQUEST_BUDGET_USA.REQUEST:
		case HIDE_USA_BUDGET_MODAL_CONFIRMACION:
			return null
		case SEND_REQUEST_BUDGET_USA.SUCCESS:
			return true
		case SEND_REQUEST_BUDGET_USA.FAILURE:
			return false
		default:
			return state
	}
}

const bussinesActivitiesById = (state = initalState.bussinesActivitiesById, action) => {
	switch (action.type) {
		case FETCH_BUSINESS_ACTIVITIES_TYPE.REQUEST:
		case FETCH_BUSINESS_ACTIVITIES_TYPE.FAILURE:
			return {}
		case FETCH_BUSINESS_ACTIVITIES_TYPE.SUCCESS:
			return action.payload.reduce(
				(acc, activityType) => ({
					...acc,
					[activityType.id]: activityType
				}),
				{}
			)
		default:
			return state
	}
}

export default {
	name: 'support',
	reducers: {
		loading,
		error,
		subjects,
		budgetRequestCompleted,
		bussinesActivitiesById
	}
}
